import {
  Button,
  FixedInfoBanner,
  useIsDesktop,
} from '@kanda-libs/ks-design-library';

import useExampleBanner from './useExampleBanner';

const ExampleBanner: React.FunctionComponent = function () {
  const { visible, returnUrl } = useExampleBanner();
  const isDesktop = useIsDesktop();
  return (
    <FixedInfoBanner visible={visible} variant="violet">
      <div className="flex flex-row flex-1 justify-between items-center gap-x-4">
        <p className="text-16-20 text-neutral-000">
          This application is an example application
        </p>
        {returnUrl && (
          <a href={returnUrl}>
            <Button.Text
              id="howdens-example-banner-home"
              label={isDesktop ? 'Return to home' : 'Dashboard'}
              variant="gradient"
              size={40}
            />
          </a>
        )}
      </div>
    </FixedInfoBanner>
  );
};

export default ExampleBanner;
